import { render, staticRenderFns } from "./interviewQuestionDetail.vue?vue&type=template&id=b525486a&scoped=true&"
import script from "./interviewQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./interviewQuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./interviewQuestionDetail.vue?vue&type=style&index=0&id=b525486a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b525486a",
  null
  
)

export default component.exports